import * as React from 'react';
import { SVGProps } from 'react';

const IconFileTableSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2h14v12H1V2Zm1 1v1h6V3H2Zm7 0v1h2V3H9Zm3 0v1h2V3h-2Zm2 2h-2v2h2V5Zm0 3h-2v2h2V8Zm0 3h-2v2h2v-2Zm-3 2v-2H9v2h2Zm-3 0v-2H2v2h6Zm-6-3h6V8H2v2Zm0-3h6V5H2v2Zm7-2v2h2V5H9Zm2 3H9v2h2V8Z"
    />
  </svg>
);
export default IconFileTableSizeS;
